import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SeasonType } from '../domain/game';
import { League } from '../domain/league';
import { SeasonService } from '../services/season.service';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-season-sync-dialog',
  templateUrl: './season-sync-dialog.component.html',
  styleUrls: ['./season-sync-dialog.component.css']
})
export class SeasonSyncDialogComponent implements OnInit {
  season: number;
  league = '1';
  // only offered when data.showSeasonType is set; undefined means all types
  seasonType: SeasonType;
  readonly seasonTypes = Object.values(SeasonType);
  showSeasonType = false;
  // only offered when data.showUndeliveredOnly is set
  undeliveredOnly = false;
  showUndeliveredOnly = false;

  leagues: League[];
  seasons = this.seasonService.getSeasons();

  title = 'Sync Season to Cockpit';
  confirmLabel = 'Sync to Cockpit';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private seasonService: SeasonService,
    private dialogRef: MatDialogRef<SeasonSyncDialogComponent>
  ) {}

  async ngOnInit() {
    this.leagues = this.data.leagues;
    if (this.data.title) {
      this.title = this.data.title;
    }
    if (this.data.confirmLabel) {
      this.confirmLabel = this.data.confirmLabel;
    }
    this.showSeasonType = !!this.data.showSeasonType;
    this.showUndeliveredOnly = !!this.data.showUndeliveredOnly;
    this.season = await firstValueFrom(this.seasonService.getCurrentSeason());
  }

  syncToCockpit() {
    this.dialogRef.close([
      this.season,
      this.league,
      this.seasonType,
      this.undeliveredOnly
    ]);
  }
}
